// extracted by mini-css-extract-plugin
export var carouselArrowLeft = "carousel-transformer-module--carousel-arrow-left--aaa6b";
export var carouselArrowRight = "carousel-transformer-module--carousel-arrow-right--b6f3c";
export var carouselImage = "carousel-transformer-module--carousel-image--1815a";
export var carouselImageFit = "carousel-transformer-module--carousel-image-fit--86158";
export var carouselTransformer = "carousel-transformer-module--carousel-transformer--2d47c";
export var modalButton = "carousel-transformer-module--modal-button--ccc03";
export var modalImage = "carousel-transformer-module--modal-image--ec2af";
export var pauseButton = "carousel-transformer-module--pause-button--c57fa";